var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"patent_apply"},[_c('div',{staticClass:"patent_title"},[_vm._v("长三角地区商标数据(季度)")]),_c('div',{staticStyle:{"width":"100%","height":"270px"},attrs:{"id":"barChart7"}})])
}]

export { render, staticRenderFns }